import { z } from 'zod';
import {
  HexColorSchema,
  IsoDateTimeSchema,
  MemberRoleSchema,
  NonEmptyTrimmedSchema,
  PlanTierSchema,
  SlugSchema,
  TenantStatusSchema,
  UuidSchema,
} from './common.js';

export const TenantSchema = z.object({
  id: UuidSchema,
  name: NonEmptyTrimmedSchema.max(80),
  slug: SlugSchema,
  plan: PlanTierSchema,
  status: TenantStatusSchema,
  branding_logo_url: z.string().url().nullable(),
  branding_primary_color: HexColorSchema.nullable(),
  trial_ends_at: IsoDateTimeSchema.nullable(),
  created_at: IsoDateTimeSchema,
});
export type Tenant = z.infer<typeof TenantSchema>;

export const CreateTenantRequestSchema = z.object({
  name: NonEmptyTrimmedSchema.max(80),
  slug: SlugSchema,
});
export type CreateTenantRequest = z.infer<typeof CreateTenantRequestSchema>;

export const UpdateTenantRequestSchema = z.object({
  name: NonEmptyTrimmedSchema.max(80).optional(),
  branding_logo_url: z.string().url().nullable().optional(),
  branding_primary_color: HexColorSchema.nullable().optional(),
});
export type UpdateTenantRequest = z.infer<typeof UpdateTenantRequestSchema>;

export const InviteMemberRequestSchema = z.object({
  email: z.string().email().toLowerCase(),
  role: MemberRoleSchema,
});
export type InviteMemberRequest = z.infer<typeof InviteMemberRequestSchema>;

export const MemberSchema = z.object({
  user_id: UuidSchema,
  email: z.string().email(),
  display_name: z.string().nullable(),
  role: MemberRoleSchema,
  created_at: IsoDateTimeSchema,
});
export type Member = z.infer<typeof MemberSchema>;
